module.exports = __webpack_public_path__ + "static/media/bulb.ecdd29c6.png";